import { useAuth } from '@/app/hooks/useAuth'
import { ReportSellers } from '@/app/services/reportService/reportSellers'
import { cn } from '@/app/utils/cn'
import { formatCpfNumber } from '@/app/utils/cpfFormater'
import { formatMoneyValue } from '@/app/utils/formatMoneyValue'
import { formatName } from '@/app/utils/formatName'
import { formatPhoneNumber } from '@/app/utils/formatPhoneNumber'
import { createColumnHelper } from '@tanstack/react-table'
import { format } from 'date-fns'

const columnHelper = createColumnHelper<ReportSellers>()

export const TableReportSellersColumnsDefinition = () => {
  const { isAdmin } = useAuth()
  const columns = [
    columnHelper.accessor('name', {
      id: 'name',
      header: () => (
        <div className="items-left flex w-full flex-col gap-1 pl-2">
          <div>Nome</div>
          <div className="text-black04">Email</div>
          <div className="block text-black04 xl:hidden">Cadastrado</div>
        </div>
      ),
      cell: ({ row }) => (
        <div className="items-left flex w-full flex-col gap-1 pl-4">
          <div>
            <p>{formatName(row.original.name)}</p>
          </div>
          <div className="text-black04">{row.original.email}</div>
          <div className="block text-black04 xl:hidden">
            {format(row.original.createdAt, 'dd/MM/yyyy, HH:mm')}
          </div>
        </div>
      ),
    }),
    columnHelper.accessor('cpf', {
      id: 'cpf',
      header: () => (
        <div
          className={cn(
            'hidden text-center 2xl:block',
            !isAdmin && '2xl:hidden',
          )}
        >
          CPF
        </div>
      ),
      cell: ({ row }) => (
        <div
          className={cn(
            'hidden text-center 2xl:block',
            !isAdmin && '2xl:hidden',
          )}
        >
          {formatCpfNumber(row.original.cpf)}
        </div>
      ),
    }),
    columnHelper.accessor('phone', {
      id: 'phone',
      header: () => <div className="hidden text-center xl:block">Telefone</div>,
      cell: ({ row }) => (
        <div className="hidden text-center xl:block">
          {formatPhoneNumber(row.original.phone)}
        </div>
      ),
    }),

    columnHelper.accessor('transactions', {
      id: 'transactions',
      header: () => (
        <div className="flex w-full flex-col items-end gap-1 pr-2 sm:items-center sm:pr-0">
          <div>Transações</div>
        </div>
      ),
      cell: ({ row }) => (
        <div className="flex w-full flex-col items-end gap-1 pr-4 sm:items-center sm:pr-0">
          <div>{row.original.transactions}</div>
          <div className="block text-black04 xl:hidden">
            {formatMoneyValue(row.original.transaction_value)}
          </div>
        </div>
      ),
    }),
    columnHelper.accessor('withdraw', {
      id: 'withdraw',
      header: () => (
        <div className="hidden sm:block">
          <div className="flex w-full flex-col items-center gap-1">
            <div>Saques</div>
          </div>
        </div>
      ),
      cell: ({ row }) => (
        <div className="hidden sm:block">
          <div className="flex w-full flex-col items-center gap-1">
            <div>{row.original.withdraw}</div>
            <div className="block text-center text-black04 lg:hidden">
              {formatMoneyValue(row.original.withdraw_value)}
            </div>
          </div>
        </div>
      ),
    }),
    columnHelper.accessor('commission', {
      id: 'comissions',
      header: () => (
        <div className="hidden text-center md:block">Comissões</div>
      ),
      cell: ({ row }) => (
        <div className="hidden text-center md:block">
          {formatMoneyValue(row.original.commission)}
        </div>
      ),
    }),
    columnHelper.accessor('withdraw_value', {
      id: 'withdraw_value',
      header: () => <div className="hidden text-center lg:block">Saques</div>,
      cell: ({ row }) => (
        <div className="hidden text-center lg:block">
          {formatMoneyValue(row.original.withdraw_value)}
        </div>
      ),
    }),
    columnHelper.accessor('transaction_value', {
      id: 'transactions_value',
      header: () => (
        <div className="hidden text-center xl:block">Transações</div>
      ),
      cell: ({ row }) => (
        <div className="hidden text-center xl:block">
          {formatMoneyValue(row.original.transaction_value)}
        </div>
      ),
    }),
    columnHelper.accessor('createdAt', {
      id: 'data',
      header: () => (
        <div className="hidden pr-4 text-right xl:block">Cadastro</div>
      ),
      cell: ({ row }) => (
        <div className="hidden pr-4 text-right xl:block">
          {format(row.original.createdAt, 'dd/MM/yyyy, HH:mm')}
        </div>
      ),
    }),
  ]
  return {
    columns,
  }
}
